import 'ol/ol.css';
import Map from 'ol/Map';
import TileJSON from 'ol/source/TileJSON';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import {get as getProj } from 'ol/proj';
import {defaults as interactionDefaluts } from 'ol/interaction';
// 控件
import {defaults as controlDefaluts} from 'ol/control';
import ZoomSlider from 'ol/control/ZoomSlider';

export default class BigMap extends Map {
    // 覆盖 species 到父级的 Map 构造函数上,这样返回的TMap就是一个Map类型了。
    static get [Symbol.species]() { return Map; }

    projection=getProj("EPSG:4326");
    maxLevel=20;
    // 声明构造函数
    constructor(id,{center=[120.158, 30.267],level=16,option={}}={
        center:[120.158, 30.267],level:16,maptype:"emg"
    }){
        // 地图滑块控件
        let zoomSlider=option.zoomSlider;
        let controls=null;
        if(zoomSlider){
            controls=new controlDefaluts().extend([    // 往地图增加控件
                new ZoomSlider(),            // 滑块缩放控件
            ])
        }else{
            controls=new controlDefaluts();
        }
        // 生成底图
        console.log("dsdfa");
        super({
            logo:false,
            target:id,
            interactions: interactionDefaluts({
                doubleClickZoom:false
            }),
            controls: controls,
            layers: [
                new TileLayer({
                    source: new TileJSON({
                    url: '/resource/hdxs/tiles.json'
                    }),
                })
            ],
            view:new View({
                center: center,
                projection: getProj("EPSG:4326"),
                zoom: level,
                maxZoom: 16,
                minZoom: 12
            })
        });
        this.level=level;
        this.center=center;
        this.id=id;
    }
}